export const getData = (options) => {
    if(!options.url) {
        console.error('호출할 api url이 없습니다.');
        return;
    }

    const defaultOption = {
        method: 'get'
    };
    const apiOptions = Object.assign({}, defaultOption, options);

    return new Promise((resolve, reject) => {
        fetch(apiOptions.url, apiOptions)
        .then(res => res.json())
        .then(data => {
            resolve(data);
        })
        .catch(err => {
            console.log(`${options.url} 조회 실패`, err);
            resolve(null);
        });
    });
};